import { combineReducers } from 'redux';
import Main from './Main';

const rootReducer = combineReducers({
  Main,
});

export default rootReducer;
